import {urlParams} from 'utils/urlParams'

import {getOrGenerateAnonymousId} from '@vio/core/src/_web/anonymousId'
import {
  createDataDogLogger,
  dataDogLogEvent
} from '@vio/core/src/analytics/components/DataDogClient'
import {experimentVariationsStore} from '@vio/core/src/experiments/components/OpticksProvider'
import {logger} from '@vio/core/src/utils/logging/logger'

import {getFullStorySessionUrl} from './fullstory'

export type LogLevel = 'debug' | 'info' | 'warn' | 'error'

const {outputToConsole = false} = urlParams()

let loggerInstance: ReturnType<typeof createDataDogLogger> | undefined

const getBoFHLoggerInstance = () => {
  if (loggerInstance) return loggerInstance

  loggerInstance = createDataDogLogger('bofh')
  return loggerInstance
}

export const logToDataDog = ({
  logName,
  metadata = undefined,
  level = 'info',
  outputToConsoleLocal = false
}: {
  logName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: any
  level?: LogLevel
  outputToConsoleLocal?: boolean
}) => {
  const fsSessionUrl = getFullStorySessionUrl()
  const experiments = experimentVariationsStore.getAll(true)
  const anonymousId = getOrGenerateAnonymousId()
  const {sourceBrand} = urlParams()
  const augmentedMetadata = {
    ...metadata,
    anonymousId,
    experiments,
    fsSessionUrl,
    sourceBrand,
    request_id: metadata?.request_id
  }

  try {
    const logger = getBoFHLoggerInstance()
    logger.log(`Checkout.${logName}`, augmentedMetadata, level)

    if (outputToConsoleLocal || outputToConsole)
      console.log(`[DataDog] ${logName}`, metadata)
  } catch (error) {
    logger.error('Failed to log on Datadog for the BoFH context', error)
  }
}

/**
 * @deprecated use logToDataDog instead and follow the pattern naming when logging
 */
export const logEvent = (
  metric: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata: any = undefined,
  level: 'info' | 'error' | 'debug' | 'warn' = 'info',
  outputToConsoleLocal = false
) => {
  const fsSessionUrl = getFullStorySessionUrl()
  const experiments = experimentVariationsStore.getAll(true)
  const anonymousId = getOrGenerateAnonymousId()
  const {sourceBrand} = urlParams()
  const augmentedMetadata = {
    ...metadata,
    anonymousId,
    experiments,
    fsSessionUrl,
    sourceBrand,
    request_id: metadata?.request_id
  }

  dataDogLogEvent(metric, augmentedMetadata, level)

  if (outputToConsoleLocal || outputToConsole)
    console.log(`[DataDog] ${metric}`, metadata)
}
